// extracted by mini-css-extract-plugin
export default {"lightBlue":"#a3bffc","infoIcon":"c4izn0feznRAahWMBVZn__infoIcon___","label":"zmeSkJKpD3nWsPFfCXgI__label___"};